"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTokenizedJudgement = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Pc = require("@jobmatchme/amplify-tools/es/api/Pc");

var _getUrlParam = require("@jobmatchme/utils/es/getUrlParam");

var _package = require("../../../package.json");

var constructPath = function constructPath(params) {
  return params.reduce(function (result, param) {
    var thisUrlParam = (0, _getUrlParam.getUrlParam)(param, false);
    return thisUrlParam ? result + '/' + thisUrlParam : result;
  }, '');
};

var constructBody = function constructBody(params) {
  return params.reduce(function (result, param) {
    var thisUrlParam = (0, _getUrlParam.getUrlParam)(param, false);
    var newResult = (0, _extends2.default)({}, result);

    if (thisUrlParam) {
      newResult[param] = param === 'timestamp' ? Number(thisUrlParam) : thisUrlParam;
    }

    return newResult;
  }, {});
};

var base64UrlDecode = function base64UrlDecode(enc) {
  try {
    return atob(decodeURI(enc));
  } catch (error) {
    return {};
  }
};

var sendTokenizedJudgement = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(user) {
    var pathParams, bodyParams, rawBody;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pathParams = ['discriminator', 'pcUuid', 'pcRevision', 'jobUuid', 'jobRevision', 'judgement'];
            bodyParams = ['token', 'timestamp', 'listMeta', 'letter'];
            rawBody = constructBody(bodyParams);
            _context.prev = 3;
            _context.next = 6;
            return _Pc.PcApi.post("/matchingService/judgements/signed".concat(constructPath(pathParams)), {
              timestamp: rawBody.timestamp,
              token: rawBody.token,
              source: 'jobletter',
              meta: {
                list: base64UrlDecode(rawBody.listMeta),
                letter: {
                  version: rawBody.letter,
                  sent: rawBody.timestamp
                },
                matching: {
                  version: _package.version,
                  authenticated: Boolean(user)
                }
              }
            });

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](3);
            console.error('Send tokenized judgement request', _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 8]]);
  }));

  return function sendTokenizedJudgement(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.sendTokenizedJudgement = sendTokenizedJudgement;